import { useMediaQuery, useTheme } from '@mui/material';

/** Stack game table columns below desktop width; iPad Pro landscape keeps the wide grid. */
export function useWrappedGameRows(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('lg'));
}
